import './js/legal/legal.js'
import './sass/legal.scss'
